import { useTranslation } from "react-i18next";

import { IMastHeadFormProps } from "./types";

import Button from "~/components/atoms/Button";
import { Icon } from "~/components/atoms/Icons";
import Typo from "~/components/atoms/Typo";
import { cn } from "~/utilities/cn";
import { ETypoColor } from "~/utilities/enums/Colors";
import { EIcon } from "~/utilities/enums/Icons";
import { ETypoTag, ETypoVariant } from "~/utilities/enums/Typo";

const MastHeadForm: React.FC<IMastHeadFormProps> = ({
  project,
  wrapperClass = "",
  onShowFlat,
  onShowPriceList,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "flex flex-col gap-8 rounded-xl px-6 py-6 lg:gap-6 lg:px-3",
        wrapperClass
      )}
    >
      <Typo
        variant={ETypoVariant.HEADER_24}
        color={ETypoColor.WHITE}
        tag="h4"
        className="text-center font-bold lg:!text-header-20"
      >
        {project?.name || ""}
      </Typo>
      {/* <div className="grid grid-cols-2 gap-x-12 gap-y-3 overflow-auto lg:max-h-[206px] lg:grid-cols-1 lg:px-6">
        {[...(project?.unitTypes || [])]?.map((unitType) => {
          const isSold = unitType.availableUnits < 1;
          return (
            <div
              key={unitType?.id}
              className={cn(
                "row flex flex-row items-center justify-between gap-3"
              )}
            >
              <Typo
                tag={ETypoTag.P}
                variant={ETypoVariant.HEADER_16}
                color={ETypoColor.WHITE}
                className="line-clamp-1 flex-1 font-bold lg:!text-header-16"
              >
                {unitType?.title || ""}
              </Typo>
              <Typo
                tag={ETypoTag.P}
                variant={ETypoVariant.BODY_TITLE_14}
                color={ETypoColor.WHITE}
                className={cn("w-fit px-2 font-normal capitalize italic")}
              >
                {isSold ? `(${t("sold_out")})` : ""}
              </Typo>
            </div>
          );
        })}
      </div> */}
      <div className="flex items-center justify-center gap-6 lg:flex-col lg:gap-3">
        <Button
          variant="tab"
          type="button"
          className={cn(
            "!rounded-[21.5px] !border !border-solid px-7 py-3 text-sub-title-16 font-bold lg:w-fit lg:text-sub-title-14",
            "border-white !bg-white"
          )}
          onClick={onShowFlat}
        >
          <Icon
            TypeIcon={EIcon.ArrowRightIcon}
            height={18}
            width={18}
            className="rotate-90 text-color"
          />
          <Typo
            tag={ETypoTag.P}
            variant={ETypoVariant.HEADER_16}
            color={ETypoColor.TEXT}
            className="font-bold capitalize"
          >
            {t("showflat_appointment_brochure")}
          </Typo>
        </Button>
        <Button
          variant="tab"
          type="button"
          className={cn(
            "!rounded-[21.5px] !border !border-solid px-6 py-3 text-sub-title-16 font-bold lg:text-sub-title-14",
            "border-modalProjectDetailSoldOutButtonBorder !bg-modalProjectDetailSoldOutButtonBackground "
          )}
          onClick={onShowPriceList}
        >
          <Icon TypeIcon={EIcon.MoneyIcon} height={18} width={18} />
          <Typo
            tag={ETypoTag.P}
            variant={ETypoVariant.HEADER_16}
            color={ETypoColor.MODAL_PROJECT_DETAIL_SOLD_OUT_BUTTON}
            className="font-bold capitalize"
          >
            {t("priceList")}
          </Typo>
        </Button>
      </div>
    </div>
  );
};

export default MastHeadForm;
